export default __webpack_public_path__ + "static/Malaysiashumblekingofnoodles-8165d632eed2505fa73cfa4819a61c0c.jpg";